/* eslint-disable react/prop-types */
import { components } from 'react-select';
import { MdExpandLess as ArrowIcon } from 'react-icons/md';
import cln from 'classnames';
import Option from '../Option';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DropdownIndicator(props) {
  return components.DropdownIndicator && /*#__PURE__*/_jsx(components.DropdownIndicator, {
    ...props,
    children: /*#__PURE__*/_jsx(ArrowIcon, {
      className: "sru_Select__arrow"
    })
  });
}
export function IndicatorSeparator() {
  return null;
}
export function MultiValueContainer({
  children
}) {
  return /*#__PURE__*/_jsxs(Option, {
    className: "sru_Select__label",
    variant: "option",
    children: [children[1], children[0]]
  });
}
export function MultiValueLabel({
  children
}) {
  return /*#__PURE__*/_jsx("span", {
    children: children
  });
}
export function ControlComponent(props) {
  return /*#__PURE__*/_jsx(components.Control, {
    className: cln('sru_Select__control', {
      'sru_Select__control--opened': props.selectProps.menuIsOpen
    }),
    ...props
  });
}